<div class="card p-input-filled full-height">
  <p-table
    #dt
    dataKey="id"
    [value]="gridItems"
    [lazy]="true"
    selectionMode="single"
    [(selection)]="selectedItem"
    [resizableColumns]="true" columnResizeMode="expand"
    (onLazyLoad)="fetchDataViaTableComponent($event)"
    [paginator]="true"
    [first]="gridMeta.lazyLoadMeta?.first ?? 0"
    [rows]="gridMeta.lazyLoadMeta?.rows ?? 20"
    [rowsPerPageOptions]="[10, 20, 50]"
    [paginatorDropdownAppendTo]="'body'"
    [totalRecords]="totalRecords"
    [sortMode]="'multiple'"
    [multiSortMeta]="gridMeta.lazyLoadMeta?.multiSortMeta"
    [filters]="gridMeta.filters!"
    [scrollable]="true" scrollHeight="var(--explorer-grid-height)"
    [tableStyle]="{ 'min-width': '50rem' }"
    styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped"
  >
    <ng-template pTemplate="header">
      <tr>
        <th *showIfDebugMode id="id" style="min-width:8rem" pSortableColumn="id" pResizableColumn>
          Id
          <p-sortIcon field="id"></p-sortIcon>
          <p-columnFilter type="numeric" field="id" display="menu" [showOperator]="false"></p-columnFilter>
        </th>

        <th id="projectType" style="min-width:10rem" pSortableColumn="projectType" pResizableColumn>
          {{ 'PROJECT.TYPE' | translate }}
          <p-sortIcon field="projectType"></p-sortIcon>
          <p-columnFilter type="text" field="projectType" display="menu" [showOperator]="false"></p-columnFilter>
        </th>

        <th id="number" style="min-width:10rem" pSortableColumn="number" pResizableColumn>
          {{ 'PROJECT.NUMBER' | translate }}
          <p-sortIcon field="number"></p-sortIcon>
          <p-columnFilter type="text" field="number" display="menu" [showOperator]="false"></p-columnFilter>
        </th>

        <th id="startDate" style="min-width:13rem" pSortableColumn="startDate" pResizableColumn>
          {{ 'PROJECT.STARTDATE' | translate }}
          <p-sortIcon field="startDate"></p-sortIcon>
          <p-columnFilter type="date" field="startDate" display="menu" [showOperator]="false"></p-columnFilter>
        </th>

        <th id="terminationDate" style="min-width:13rem" pSortableColumn="terminationDate" pResizableColumn>
          {{ 'PROJECT.TERMINATIONDATE' | translate }}
          <p-sortIcon field="terminationDate"></p-sortIcon>
          <p-columnFilter type="date" field="terminationDate" display="menu" [showOperator]="false"></p-columnFilter>
        </th>

        <th id="status" style="min-width:10rem" pSortableColumn="status" pResizableColumn>
          {{ 'STATUS' | translate }}
          <p-sortIcon field="status"></p-sortIcon>
          <p-columnFilter field="status" display="menu" [showOperator]="false" type="equals">
            <ng-template pTemplate="filterElement" let-value let-filter="filterCallback">
              <p-dropdown
                [options]="statusOptions"
                [ngModel]="value"
                (onChange)="filter($event.value)"
                optionLabel="label"
                optionValue="value"
                [placeholder]="'SELECT_STATUS' | translate">
              </p-dropdown>
            </ng-template>
          </p-columnFilter>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item>
      <tr [pSelectableRow]="item" (dblclick)="onRowDblClick($event, item.treeNode)">
        <td *showIfDebugMode>{{ item.id }}</td>
        <td>{{ item.projectType }}</td>
        <td>{{ item.number }}</td>
        <td>{{ item.startDate | date: dateFormat }}</td>
        <td>{{ item.terminationDate | date: dateFormat }}</td>
        <td>{{ item.status | translate }}</td>
      </tr>
    </ng-template>
    <ng-template id="buttonCreate" pTemplate="paginatorleft">
      <button mat-flat-button color="primary" class="m-1" (click)="createNew()"
              *hasPermission="Permission.PROJECT_CREATE">
        <mat-icon>add</mat-icon>
        {{ 'CREATE' | translate }}
      </button>
      <button mat-flat-button [disabled]="selectedItem === null" (click)="delete()"
              *hasPermission="Permission.PROJECT_DELETE">
        <mat-icon>clear</mat-icon>
        {{ 'DELETE.DELETE' | translate  }}
      </button>
    </ng-template>
  </p-table>
</div>
